import React from 'react'
import './style/Princing.css'
import PrincingCard from './Cards/PricingCard'
import sketch from '../imgs/sketch.svg'

function Pricing() {
    return (
        <div className="pricing" id="pricing">
            <span>Pricing</span>
            <h2>Our Prices</h2>
            <div className="cards">
                <PrincingCard title="Basic" price={75} desc="Cillum magna exercitation "/>
                <PrincingCard title="Standard" price={250} desc="Cillum magna exercitation "/>
                <PrincingCard title="Premium" price={350} desc="Cillum magna exercitation "/>
            </div>
        </div>
    )
}

export default Pricing
